export interface ScoringV3 {
    id: string;
    results: ScoringResult[];
}

export interface ScoringResult {
    id: string;
    type: string;
    applicationScope: ApplicationScope;
    result: string;
    perimeter: string;
    reliability: number;
    actions?: Action[];
    message?: string;
    impactedSalesQuotes: ImpactedSalesQuote[];
    unlockingFeature: UnlockingFeature;
}

export interface Action {
    type: ScoringAction;
    amount?: number;
}

export interface UnlockingFeature {
    unlockable: boolean;
}

export interface ApplicationScope {
    type: ScoringScope;
    businessLine?: string;
    category?: string;
}

export interface ImpactedSalesQuote {
    idSalesQuote: string;
}

export enum ScoringType {
    GLOBAL_RESULT = 'ResultatGlobal',
}

export enum ScoringScope {
    MARKET_LINE = 'ParLigneMarcheMetier',
    REQUESTED_ACT = 'ParActeDemande',
}

export enum ScoringAction {
    RETRAIT_EDP = 'RETRAIT_EDP',
    RETRAIT_CREDIT = 'RETRAIT_CREDIT',
    AVANCE_SUR_CONSOMMATION = 'AVANCE_SUR_CONSOMMATION',
    REGULARISATION_IMPAYE = 'REGULARISATION',
    VERIFICATION_BANCAIRE = 'VERIFICATION_BANCAIRE',
}
